export const BUILD_MISMATCH_RELOAD_KEY = "tellerwand-build-mismatch-reload";
export const BUILD_VERSION_POLL_MS = 5 * 60 * 1000;

export function getLoadedBuildId(): string | null {
  if (typeof document === "undefined") return null;
  const meta = document.querySelector('meta[name="tellerwand-build-id"]');
  const buildId = meta?.getAttribute("content")?.trim();
  return buildId || null;
}

/**
 * Fetch Live Build Id.
 */
export async function fetchLiveBuildId(): Promise<string | null> {
  if (typeof fetch === "undefined") return null;

  try {
    const response = await fetch(`/build-info.json?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "same-origin",
    });
    if (!response.ok) return null;

    const data = (await response.json()) as { buildId?: unknown };
    return typeof data.buildId === "string" && data.buildId.length > 0 ? data.buildId : null;
  } catch {
    return null;
  }
}

/**
 * Attempt Build Mismatch Reload.
 */
export function attemptBuildMismatchReload(
  liveBuildId: string,
  loadedBuildId: string | null
): boolean {
  if (!loadedBuildId || liveBuildId === loadedBuildId) return false;
  if (typeof sessionStorage === "undefined") return false;
  if (sessionStorage.getItem(BUILD_MISMATCH_RELOAD_KEY) === "true") return false;

  sessionStorage.setItem(BUILD_MISMATCH_RELOAD_KEY, "true");
  globalThis.location.reload();
  return true;
}

/**
 * Setup Build Version Poll.
 */
export function setupBuildVersionPoll(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const loadedBuildId = getLoadedBuildId();
  if (!loadedBuildId) return;

  const check = async () => {
    const liveBuildId = await fetchLiveBuildId();
    if (liveBuildId) {
      attemptBuildMismatchReload(liveBuildId, loadedBuildId);
    }
  };

  void check();

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      void check();
    }
  });

  window.setInterval(() => {
    void check();
  }, BUILD_VERSION_POLL_MS);
}
